const formatNumber = (number: number) => Intl.NumberFormat("de").format(number);

const formatFirstChartUppercase = (word: string) =>
  word.charAt(0).toUpperCase() + word.slice(1);

export { formatNumber, formatFirstChartUppercase };
